
export function generateIndustryLabel(industries) {
    if (!industries || industries.length === 0) return '';

    if(industries.length === 1) {
        return industries[0];
    }

    if(industries.length === 2) {
        return `${industries[0]} & ${industries[1]}`;
    }
    if(industries.length > 2) {
        return 'Residential, Commercial & Senior Living';
    }
}